import { LINKS_FILTER_FULL_TEXT } from '@monash/portal-frontend-common';
import c from '../category-new.module.scss';

// Sorts filters suffixed with GENERAL to the top,
// and then sorts alphabetically
export const generalFirstThenAlphabetical = (a, b) => {
  if (a.includes('GENERAL') && !b.includes('GENERAL')) return -1;
  if (b.includes('GENERAL') && !a.includes('GENERAL')) return 1;

  return a.localeCompare(b);
};

export const getDropdownFilterList = (filters) => {
  const topLevelsSet = new Set(filters.map((filter) => filter.split('_')[0]));
  const topLevels = Array.from(topLevelsSet);

  return topLevels
    .flatMap((topLevel) => {
      const topLevelFilters = filters.filter((filter) =>
        filter.startsWith(topLevel)
      );
      const generalFilter = `${topLevel}_GENERAL`;

      // Add the general filter if it doesn't exist
      const filtersWithGeneral = topLevelFilters.includes(generalFilter)
        ? topLevelFilters
        : [generalFilter, ...topLevelFilters];

      return filtersWithGeneral.sort(generalFirstThenAlphabetical);
    })
    .map((filter) => {
      const title = LINKS_FILTER_FULL_TEXT[filter];

      if (filter.includes('GENERAL')) {
        return { text: title, rawText: title, value: filter };
      }

      const shortenedTitle = title.split('-')?.[1]?.trim();
      const includeCountry =
        title.includes('International') || title.includes('Domestic');
      const finalTitle = includeCountry ? title : shortenedTitle;

      return {
        text: <span className={c.withListDot}>{finalTitle}</span>,
        rawText: finalTitle,
        value: filter,
      };
    });
};
